import { cn } from '@/lib/cn.js';

export type TabItem<T extends string> = {
  key: T;
  label: string;
  /** Yonidagi son — nechta element bor (komplektatsiyalar, hujjatlar). */
  count?: number | undefined;
};

/**
 * Yorliqlar — MAKETDAN (`D2`, `D3`, `D5`).
 *
 * Faol yorliq PASTDAN 3px brend chizig'i bilan belgilanadi, qator esa
 * ingichka kulrang chiziq ustida turadi. Rangli to'ldirilgan tugmalar
 * ATAYLAB ishlatilmaydi: ular sahifadagi asosiy harakat tugmalari bilan
 * bir xil ko'rinib, nima bosiladigan joyligini chalkashtirardi.
 *
 * Tartib raqami (`01`, `02`) mono shriftda — maketda yorliq matnidan
 * oldin turadi va uzun ro'yxatda o'rinni ko'rsatadi.
 */
export function Tabs<T extends string>({
  items,
  value,
  onChange,
  numbered = false,
  className,
}: {
  items: ReadonlyArray<TabItem<T>>;
  value: T;
  onChange: (key: T) => void;
  numbered?: boolean;
  className?: string;
}) {
  return (
    <div
      role="tablist"
      className={cn('flex gap-0.5 overflow-x-auto border-b border-n-200', className)}
    >
      {items.map((item, index) => {
        const active = item.key === value;

        return (
          <button
            key={item.key}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(item.key)}
            className={cn(
              '-mb-px flex items-center gap-2 border-b-[3px] px-4 py-3 text-[13.5px] font-semibold whitespace-nowrap',
              active
                ? 'border-brand-600 text-brand-600'
                : 'border-transparent text-n-600 hover:text-n-900',
            )}
          >
            {numbered && (
              <span aria-hidden className="font-mono text-[11px] text-n-400">
                {String(index + 1).padStart(2, '0')}
              </span>
            )}
            {item.label}
            {item.count !== undefined && (
              <span
                className={cn(
                  'min-w-[22px] px-1.5 py-0.5 text-[11.5px] font-bold tabular',
                  active ? 'bg-brand-600 text-white' : 'bg-n-100 text-n-600',
                )}
              >
                {item.count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
